module.exports = __webpack_public_path__ + "img/Twin-Creek.00b1c2f2.png";